import api from '../../plugins/api';

// Новые QR ведут по токену (GUID), старые — по числовому id.
const getDocumentHistory = (idOrToken) => {
  const params = /^\d+$/.test(idOrToken) ? { id: idOrToken } : { token: idOrToken };
  return api.get('/api/documents/getDocumentHistory', params);
};

export default getDocumentHistory;
